module.exports = __webpack_public_path__ + "components/flag/static/square/sr-8ffc1b2ab2fa1c4c5dc7bae4fe437896.svg";